<template>
  <transition name="slide">
    <div class="g-nav" v-show="showFlag">
      <ul class="nav-list header">
        <template v-if="userInfo">
          <p class="titleName">
            <!-- <a href="javascript:void(0);" class="titleName"></a> -->
            {{ userInfo.CustName }}
          </p>
          <li class="item titleDetailBox">
            <a href="javascript:void(0);" class="titleDetail">{{
              userInfo.CustUser
            }}</a>
          </li>
          <p class="uid">{{ userInfo.CustCode }}</p>
        </template>
        <template v-else>
          <li class="item">
            <router-link
              :to="{ path: '/login/index' }"
              @click.native="
                selectItem({ name: '登录/注册', path: '/login/index' }, -1)
              "
            >
              <h2>登录/注册</h2>
            </router-link>
            <p class="login-text">造物云 | 造物云创新，数字芯制造</p>
          </li>
        </template>
      </ul>
      <scroll ref="scroll" :data="{}">
        <div class="nav-content">
          <ul class="nav-list master">
            <li class="item" v-for="(item, index) in navListMain" :key="index">
              <img :src="visitUrl == item.path ? item.icon : item.ashIcon" />
              <router-link
                :to="{ path: item.path }"
                @click.native="selectItem(item, index)"
                exact
                >{{ item.name }}</router-link
              >
            </li>
          </ul>
          <!-- <ul class="nav-list master" v-if="userInfo">
        <li class="item" v-for="(item, index) in navListShortcut" :key="index">
          <router-link :to="{path: item.path}" @click.native="selectItem(item, index)">{{item.name}}</router-link>
        </li>
      </ul> -->
          <ul class="nav-list master">
            <li class="item" v-for="(item, index) in navListOther" :key="index">
              <img :src="visitUrl == item.path ? item.icon : item.ashIcon" />
              <router-link
                :to="{ path: item.path }"
                @click.native="selectItem(item, index)"
                v-if="item.name !== '客服'"
                >{{ item.name }}</router-link
              >
              <span v-else>{{ item.name }}</span>
              <span class="number" v-if="item.name == '客服'"
                >0755-5283248</span
              >
            </li>
          </ul>

          <ul class="nav-list footer" v-if="userInfo">
            <li class="item">
              <a href="javascript:void(0);" @click="loginOutHandle">退出登录</a>
            </li>
          </ul>
        </div>
      </scroll>
    </div>
  </transition>
</template>

<script type="text/ecmascript-6">
import { routerPrefix, toastLoading, common } from "assets/js/util";
import { mapMutations, mapGetters, mapActions } from "vuex";
import { loginOut } from "api/login";
import { ERR_OK } from "api/config";
import Scroll from "base/scroll/scroll";

export default {
  props: {
    showFlag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      routerPrefix,
      navListShortcut: [
        {
          name: "我的订单",
          path: "/userCenter/myOrder"
        },
        {
          name: "快捷入口",
          path: "/shortcut"
        }

      ],
      navListOther: [
        // {
        //   name: "我的余额",
        //   path: "/0",
        //   icon: require("./images/money_icon_s@2x.png"),
        //   ashIcon: require("./images/money_icon@2x.png")
        // },
        // {
        //   name: "我的订单",
        //   path: "/me/order",
        //   icon: require("./images/order_icon_s@2x.png"),
        //   ashIcon: require("./images/order_icon@2x.png")
        // },
        // {
        //   name: "发票管理",
        //   path: "/me/orderDetail",
        //   icon: require("./images/invoice_icon_s@2x.png"),
        //   ashIcon: require("./images/invoice_icon@2x.png")
        // },
        {
          name: "设置",
          path: "/me/setUp",
          icon: require("./images/set_icon_s@2x.png"),
          ashIcon: require("./images/set_icon@2x.png")
        },
        {
          name: "客服",
          path: "",
          icon: require("./images/call_icon_s@2x.png"),
          ashIcon: require("./images/call_icon@2x.png")
        },
        {
          name: "关于我们",
          path: "/aboutUs",
          icon: require("./images/icon_about_s@2x.png"),
          ashIcon: require("./images/icon_about@2x.png")
        }
      ],
      loginOutLoading: false,
      visitUrl: ""
    };
  },
  created() {
    this.rediUrl = encodeURIComponent(window.location.href);
  },
  computed: {
    navListMain() {
      var list = [
        {
          name: "首页",
          path: "/",
          icon: require("./images/home_icon_s@2x.png"),
          ashIcon: require("./images/home_icon@2x.png")
        },
        {
          name: "IDH方案",
          path: "/projectNew",
          icon: require("./images/IDH_icon_s@2x.png"),
          ashIcon: require("./images/IDH_icon@2x.png")
        },
        // {
        //   name: "元器件",
        //   path: "/comp/index",
        //   icon: require("./images/nav_parts_icon_s@2x.png"),
        //   ashIcon: require("./images/nav_parts_icon@2x.png")
        // },
        {
          name: "PCB Layout",
          path: "/cad",
          icon: require("./images/nav_cad_icon_s.png"),
          ashIcon: require("./images/nav_cad_icon.png")
        },
        {
          name: "EES",
          path: "/server",
          //  path: "/server",
          icon: require("./images/nav_ees_icon_s.png"),
          ashIcon: require("./images/nav_ees_icon.png")
        },
        {
          name: "造物动态",
          path: "/kbNews",
          icon: require("./images/icon_ dynamic_s@2x.png"),
          ashIcon: require("./images/icon_ dynamic_n@2x.png")
        }
        // {
        //   name: "购物车",
        //   path: "/shop/shoppingCart",
        //   icon: require("./images/nav_shop_icon_s@2x.png"),
        //   ashIcon: require("./images/nav_shop_icon@2x.png")
        // }, {
        //   name: "我的订单",
        //   path: "/me/order",
        //   icon: require("./images/order_icon_s@2x.png"),
        //   ashIcon: require("./images/order_icon@2x.png")
        // }
      ];
      if (this.userInfo) {
        list.push(
          //   {
          //   name: "个人中心",
          //   path: "/me"
          // }
          {
            name: "购物车",
            path: "/shop/shoppingCart",
            icon: require("./images/nav_shop_icon_s@2x.png"),
            ashIcon: require("./images/nav_shop_icon@2x.png")
          },
          {
            name: "询价订单",
            path: "/comp/inquiryOrder",
            icon: require("./images/consult_icon_s@2x.png"),
            ashIcon: require("./images/consult_icon@2x.png")
          },
          {
            name: "我的订单",
            path: "/me/order",
            icon: require("./images/order_icon_s@2x.png"),
            ashIcon: require("./images/order_icon@2x.png")
          }
        );
      }
      this.visitUrl = this.$route.path;
      return list;
    },

    ...mapGetters(["authorToken", "userInfo"])
  },
  methods: {
    selectItem(data, index) {
      this.visitUrl = data.path;
      this.$emit("selectItem", data);
    },
    loginOutHandle() {
      let toast = toastLoading(this.$toast, "退出中...");
      this._loginOut()
        .then(res => {
          if (res.code) {
            if (res.code != ERR_OK) {
              return Promise.reject(res);
            }
            this.signOut();
            this.$router.replace({
              path: "/"
            });
          }
        })
        .catch(erro => {
          if (!erro.isCancel) {
            this.$toast(erro.message);
          }
        })
        .finally(() => {
          toast.clear();
        });
    },
    _loginOut() {
      var param = {
        UID: this.userInfo.UserId,
        UserCode: this.userInfo.UserCode,
        UserName: this.userInfo.CustName
      };
      return loginOut(param);
    },
    ...mapMutations({
      UpdateAuthorization: "UPDATE_AUTHORTOKEN"
    }),
    ...mapActions(["updateUserInfo", "signOut"])
  },
  components: {
    Scroll
  }
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import "~assets/scss/compile";
@import "nav";
</style>



// WEBPACK FOOTER //
// src/components/common/nav/nav.vue